import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Tendance négative — flèche descendante duotone */
export const TrendingDownIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Zone sous la courbe (warning tint) */}
      <path
        d="M3 5v6l5.5-3 5 7 7.5-5v-5H3z"
        fill="hsl(var(--warning))" fillOpacity="0.5"
      />
      {/* Courbe descendante */}
      <path
        d="M3 8l5.5 3 5 5 7.5 3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Flèche pointe */}
      <path
        d="M16 19h5v-5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
TrendingDownIcon.displayName = "TrendingDownIcon";
